var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiveSquare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.80998 2H16.18C19.82 2 21.99 4.17 21.99 7.81V16.18C21.99 19.82 19.82 21.99 16.18 21.99H7.80998C4.16998 21.99 1.99998 19.82 1.99998 16.18V7.81C1.99998 4.17 4.16998 2 7.80998 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9801 12.59H13.4101C13.8201 12.59 14.1601 12.93 14.1601 13.34C14.1601 13.75 13.8201 14.09 13.4101 14.09H9.17012C9.07012 14.09 8.98013 14.07 8.88013 14.03C8.70013 13.95 8.55012 13.81 8.47012 13.62C8.43012 13.53 8.41012 13.43 8.41012 13.33V9.09999C8.41012 8.68999 8.75012 8.34999 9.16012 8.34999C9.57012 8.34999 9.91012 8.68999 9.91012 9.09999V11.53L14.2901 7.15C14.5801 6.86 15.0601 6.86 15.3501 7.15C15.6401 7.44 15.6401 7.91999 15.3501 8.20999L10.9801 12.59Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29006 16.28C5.42006 15.89 5.84007 15.68 6.24007 15.81C9.96007 17.05 14.0501 17.05 17.7701 15.81C18.1601 15.68 18.5901 15.89 18.7201 16.28C18.8501 16.67 18.6401 17.1 18.2501 17.23C16.2401 17.9 14.1301 18.24 12.0101 18.24C9.89006 18.24 7.78007 17.9 5.77007 17.23C5.37007 17.09 5.16006 16.67 5.29006 16.28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveSquare2);
export default __webpack_public_path__ + "static/media/receive-square-2.92843acc210ca0b64813c98e9c29d7bb.svg";
export { ForwardRef as ReactComponent };